import { resolveLanguageList } from '../tutorialSlug/utils/resolveLanguageList'
import type { TutorialSection } from '../types'

import { documentationArticleUrlPath } from './documentationArticleUrlPath'

export function resolveDocumentationSlug(
  slug: string[],
  sections: TutorialSection[]
): { articlePath: string; language: string } | null {
  if (slug.length === 0) return null

  const joined = slug.join('/')

  const singleLangMatch = sections.find((s) => {
    const langs = resolveLanguageList(s)
    return langs.length === 1 && documentationArticleUrlPath(s.path) === joined
  })
  if (singleLangMatch) {
    const langs = resolveLanguageList(singleLangMatch)
    return { articlePath: singleLangMatch.path, language: singleLangMatch.defaultLanguage ?? langs[0]! }
  }

  if (slug.length >= 2) {
    const lang = slug[slug.length - 1]!.toLowerCase()
    const urlArticlePath = slug.slice(0, -1).join('/')
    const multi = sections.find(
      (s) => documentationArticleUrlPath(s.path) === urlArticlePath && (s.languages ?? []).includes(lang)
    )
    if (multi) return { articlePath: multi.path, language: lang }

    const merged = sections.find((s) => {
      const langs = resolveLanguageList(s)
      return langs.length <= 1 && documentationArticleUrlPath(s.path) === urlArticlePath
    })
    if (merged) {
      const langs = resolveLanguageList(merged)
      return { articlePath: merged.path, language: merged.defaultLanguage ?? langs[0]! }
    }
  }

  return null
}
